import React from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaUser, FaShoppingCart } from "react-icons/fa";
import "./Header1.css";

const Header1 = () => {
  return (
    <header className="header" style={{backgroundColor:"darkcyan" , fontWeight:"bolder"}}>
      <div className="top-header">
        {/* Search */}
        {/* <div className="search-container">
          <FaSearch className="search-icon" />
          <input type="text" placeholder="Search" />
        </div> */}

        {/* Logo */}
        {/* <div className="logo-container">
          <Link to="/">
            <img src="/logo.png" alt="Aswins Logo" className="logo" />
          </Link>
        </div> */}

        {/* Account & Cart */}
        {/* <div className="account-cart">
          <Link to="/account" className="account">
            Account
          </Link>
          <Link to="/cart" className="cart">
            <FaShoppingCart className="cart-icon" />
            <span>Cart</span>
          </Link>
        </div> */}
      </div>

      {/* Navigation */}
      <nav className="nav">
        <Link to="/savouries">Savouries</Link>
        <Link to="/products">All products</Link>
        <Link to="/combo">Combos</Link>
        <Link to="/sweets">Sweets</Link>
        <Link to="/others">Others</Link>
        <Link to="/gifts">Gifting</Link>
        {/* <Link to="/contact">Contact</Link>
        <Link to="/corporate-gifting">Corporate Gifting</Link> */}
      </nav>
    </header>
  );
};

export default Header1;
